
import { defineComponent, reactive } from 'vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IDTOPedidoCompraRegistroAtividade } from '@/models/DTO/Compras/IDTOPedidoCompraRegistroAtividade';

export default defineComponent({
  name: 'PedidoCompraHistorico',
  props: {
    registros: {
      type: Array as () => IDTOPedidoCompraRegistroAtividade[],
      required: true,
    },
  },
  components: {
    MensagemSemDados,
  },
  setup(props) {
    const state = reactive({});

    return {
      props,
      state,
      UtilitarioData,
    };
  },
});
